
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faCog, faEnvelopeOpen, faSearch, faSignOutAlt, faUserShield } from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import { Row, Col, Nav, Form, Image, Navbar, Dropdown, Container, ListGroup, InputGroup } from '@themesberg/react-bootstrap';
import fetchWrapper from "../utils/fetch/fetchWrapper";

import NOTIFICATIONS_DATA from "../data/notifications";
import Profile3 from "../assets/img/team/profile-picture-3.jpg";


export default (props) => {
  const [notifications, setNotifications] = useState([]);
  const [allRead, setAllRead] = useState(false)
  const areNotificationsRead = notifications.reduce((acc, notif) => acc && notif.read, true);

  useEffect(() => {
    getNotifications()        
  }, [allRead]);

  const markNotificationsAsRead = () => {
    fetchWrapper()
          .doPost({
              url: "/mark_as_read",           
              onSuccess: async (response) => {
                setAllRead(true)
              },
              onError: (response) => {
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
  };
  const getNotifications = () =>{
    fetchWrapper()
          .doGet({
              url: "/get_notifications_admin",           
              onSuccess: async (response) => {
                const sortedNotifications = response.data.sort((a, b) => new Date(b.created) - new Date(a.created));
                setNotifications(sortedNotifications);
              },
              onError: (response) => {
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
  }
  const notificationRead = (id) =>{
    fetchWrapper()
          .doPost({
              url: "/notification_read",
              body:{
                noti_id: id
              } ,         
              onSuccess: async (response) => {
              },
              onError: (response) => {
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
        
  }

  const Notification = (props) => {
    const { title, content, navigation, read, id} = props;
    const readClassName = read ? "" : "text-danger";
    

    return (
      <ListGroup.Item action href={"/intranet/"+ navigation} className="border-bottom border-light"  onClick={() => notificationRead(id)}>
        <Row className="align-items-center">          
          <Col className="ps-0 ms--2">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="h6 mb-0 text-small">{title}</h4>
              </div>
              <div className="text-end">
              </div>
            </div>
            <p className={readClassName}>{content}</p>
          </Col>
        </Row>
      </ListGroup.Item>
    );
  };

  return (
    <Navbar variant="dark" expanded className="ps-0 pe-2 pb-0">
      <Container fluid className="px-0">
        <div className="d-flex justify-content-between w-100">
          <div className="d-flex align-items-center">
            <Form className="navbar-search">
             <Form.Group id="topbarSearch">
               <InputGroup className="input-group-merge search-bar">
                 <InputGroup.Text><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
                 <Form.Control type="text" placeholder="Search" />
               </InputGroup>
             </Form.Group>
            </Form>
          </div>
          <Nav className="align-items-center">
            <Dropdown as={Nav.Item}>
             <Dropdown.Toggle as={Nav.Link} className="text-dark icon-notifications me-lg-3">
               <span className="icon icon-sm">
                 <FontAwesomeIcon icon={faBell} className="bell-shake" />
                 {areNotificationsRead ? null : <span className="icon-badge rounded-circle unread-notifications" />}
               </span>
             </Dropdown.Toggle>
             <Dropdown.Menu className="dashboard-dropdown notifications-dropdown dropdown-menu-lg dropdown-menu-center mt-2 py-0">
               <ListGroup className="list-group-flush">
                 <Nav.Link href="#" className="text-center text-primary fw-bold border-bottom border-light py-3">
                   Notifications
                 </Nav.Link>

                 {notifications.map(n => <Notification key={`notification-${n.id}`} {...n}/>)}

                 <Dropdown.Item className="text-center text-primary fw-bold py-3" onClick={markNotificationsAsRead}>
                   View all
                 </Dropdown.Item>
               </ListGroup>
             </Dropdown.Menu>
            </Dropdown>

            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                <div className="media d-flex align-items-center">
                  <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                    <span className="mb-0 font-small fw-bold">Seifrei Admin</span>
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2">
                <Dropdown.Item className="fw-bold">
                  <FontAwesomeIcon icon={faSignOutAlt} className="text-danger me-2" /> Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};
